import React from 'react'
import { Typography } from '../base-ui'
import { BsTextRight } from 'react-icons/bs'
import { css } from '@emotion/react'

function IconTitle({ fontSize = '0.9rem', icon = <BsTextRight />, title }) {
    const mainStyle = css`
        padding: 0.5rem;
        display: flex;
        gap: 0.5rem;
        margin-bottom: 0;
    `
    return (
        <Typography type="h4" fontSize={fontSize} css={mainStyle} hoverColor="primary">
            <span>{icon}</span>
            {title}
        </Typography>
    )
}

export default IconTitle